import { PageResponse } from '../../core';
import { UserGroup } from '../../core/models/user-group';
import { Customer } from '../../core/models/customer';


export interface AvailableRole {
    domain: string;
    roles: string[];
}

export interface RolesPerDomain {
    user: string[];
    customer: string[];
    application: string[];
}

export interface UserRole {
    name: string;
}

export interface User {
    id: string;
    name: string;
    customer: Customer;
    email: string;
    password: string;
    repeat_pass: string;
    lastIP: string;
    lastLogin: string;
    image: string;
    userRole: UserRole;
    status: string;
    enabled: boolean;
    username: string;
    availableRoles: AvailableRole[];
    rolesPerDomain: RolesPerDomain;
    accountNonLocked: boolean;
    credentialsNonExpired: boolean;
    accountNonExpired: boolean;
    userGroups: UserGroup[];
    creationDate: Date;
    modifyDate: Date;
}

export interface UserApiKey {
  value: string;
}

export class UserResponse extends PageResponse {
    content: User[];
}
